/// <amd-module name="Wiki/Search/Constants" />
export namespace CustomerIntelligenceConstants {
    export const TtiSearchScenarioName = "WikiSearchTTIScenario";
    export const SubSequentSearchScenarioName = "WikiSearchTTIScenario";
}
